export default {
  getStockItemFile: (state) => state.stockItemFile,
};
